import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import {PixComponent} from './components/pix/pix.component';
import { PosComponent } from './components/pos/pos.component';

const routes: Routes = [
  {
    path: 'checkout/404',
    component: NotFoundComponent,
    data: { title: '404' }
  },
  {
    path: 'checkout',
    component: CheckoutComponent,
    data: { title: 'Checkout' }
  },
  {
    path: 'checkout/pix',
    component: PixComponent,
    data: { title: 'Pix' }
  },
  {
    path: 'checkout/pos',
    component: PosComponent,
    data: { title: 'Maquininha' }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class CheckoutRoutingModule { }
